const install = (Vue, vm) => {
	
	uni.$u.http.setConfig((config) => {
	    config.baseURL = vm.$baseUrl;
		config.timeout = 60000;
	    return config;
	})
	
	let wxLogin = (params = {}) => vm.$u.http.get('web/account/wxLogin', { params });	// 小程序登录
	let getUserInfo = (data = {}) => vm.$u.http.post('web/account/getUserInfo', data);	// 获取当前登录的用户信息
	let findShopBanner = (params = {}) => vm.$u.http.get('web/banner/findShopBanner', { params });	// 获取该商城首页轮播图
	let getGoodsLabelsByType = (params = {}) => vm.$u.http.get('web/labels/getGoodsLabelsByType', { params });	// 获取分类信息
	let goodsPage = (data = {}) => vm.$u.http.post('web/goods/goodsPage', data);	// 商品列表
	let wxPhone = (data = {}) => vm.$u.http.post('web/account/wxPhone', data);	// 绑定手机号
	let myInfo = (params = {}) => vm.$u.http.get('web/home/myInfo', { params });	// 我的信息
	let ordersStatistics = (params = {}) => vm.$u.http.get('web/orders/ordersStatistics', { params });	// 订单统计
	let findNoticeCardDTOPage = (data = {}) => vm.$u.http.post('web/notice/findNoticeCardDTOPage', data);	// 查询用户通知
	let orderPage = (data = {}) => vm.$u.http.post('web/orders/orderPage', data);	// 订单列表
	let addCart = (data = {}) => vm.$u.http.post('web/shopCart/addCart', data);	// 加入购物车
	let goodsInfo = (params = {}) => vm.$u.http.get('web/goods/goodsInfo', { params });	// 商品详情
	let shopCartPage = (data = {}) => vm.$u.http.post('web/shopCart/goodsPage', data);	// 购物车列表
	
	vm.$u.api = {
		wxLogin,
		getUserInfo,
		findShopBanner,
		getGoodsLabelsByType,
		goodsPage,
		wxPhone,
		myInfo,
		ordersStatistics,
		findNoticeCardDTOPage,
		orderPage,
		addCart,
		goodsInfo,
		shopCartPage
	};
}

export default { install }